import React, { useEffect } from 'react';

import { Loader } from '@cision/rover-ui';

import { useDispatch, useSelector } from 'react-redux';

import { SvgIcon, Button as TkUiButton } from '@trendkite/ui';

import TranslatedMessage from 'i18n/TranslatedMessage';

import { FilterId, Namespace } from './filters-definintions';
import {
  getFiltersActionCreator,
  getFilterValuesActionCreator,
  getSelectedFiltersActionCreator,
  removeAllSelectedFiltersActionCreator,
} from './new-widget-filters-reducer';
import {
  widgetFiltersSelector,
  widgetFiltersLoadingSelector,
  allWidgetFilterSelectedValuesSelector,
} from './new-widget-filters-selector';
import messages from './new-widget-filters-tab.messages';
import styles from './new-widget-filters-tab.module.css';
import PersistentWidgetFilter from './persistent-widget-filter/persistent-widget-filter';

const WidgetFiltersTab = ({ widgetId, searches }) => {
  // const [applyAll, setApplyAll] = useState(false);
  const widgetFilters = useSelector(widgetFiltersSelector);
  const areWidgetFiltersLoading = useSelector(widgetFiltersLoadingSelector);
  const selectedFilterValues = useSelector(
    allWidgetFilterSelectedValuesSelector,
  );
  const dispatch = useDispatch();

  const searchId = searches.length > 0 ? searches[0].id : '';

  useEffect(() => {
    dispatch(
      getFiltersActionCreator(Namespace.WAG_DASHBOARDS2, () => {
        dispatch(getSelectedFiltersActionCreator(searchId, widgetId));
      }),
    );
  }, [dispatch, searchId, widgetId]);

  const onRemoveSavedFilter = (filterId: string) =>
    dispatch(removeAllSelectedFiltersActionCreator(filterId));

  const onClick = (filterId: FilterId) => {
    if (!areWidgetFiltersLoading) {
      dispatch(getFilterValuesActionCreator(filterId));
    }
  };

  const renderCurrentSelectedFilterValues = () =>
    /*This type is type of any because the value which is the id of the filterValue
  will conflict with the Key and Id of the component. There is no current real ID for
  a filter value, it has to be addressed in a future ticket after data structure is modified*/
    selectedFilterValues.map((sf: any) => {
      if (sf.values.length > 0) {
        return (
          <TkUiButton
            key={sf.id}
            modifiers={[
              'clearable-pill',
              'flex',
              'round',
              'large',
              'auto-width',
            ]}
            style={{ marginBottom: '10px' }}
          >
            <span>
              <span className={styles.filterLabel}>{sf.label || sf.name}</span>:{' '}
              {sf.values.length > 1
                ? `${sf.values[0].key} +${sf.values.length - 1}`
                : sf.values[0].key}
            </span>
            <div
              data-qa="bJI-8D3A_iBLbTqyX03JD"
              className={styles.pillCross}
              onClick={() => onRemoveSavedFilter(sf.id)}
              onKeyDown={() => {}}
              role="button"
              tabIndex={0}
            >
              <SvgIcon
                icon="cross"
                width={15}
                height={15}
                modifiers={['flex']}
              />
            </div>
          </TkUiButton>
        );
      }
    });

  const renderWidgetFilters = () =>
    /*This type is type of any because the value which is the id of the filterValue
  will conflict with the Key and Id of the component. There is no current real ID for
  a filter value, it has to be addressed in a future ticket after data structure is modified*/
    widgetFilters?.map((f: any) => {
      return (
        <PersistentWidgetFilter
          data-qa="dGqkFtzaqDuFsH6sUxiAN"
          key={f.id}
          id={f.id}
          name={f.label || f.name}
          onClick={() => {
            onClick(f.id);
          }}
          isMultiValue={f.multivalued}
          areFilterValuesLoading={f.isLoadingValues}
        />
      );
    });

  return (
    <div className={styles.container}>
      {areWidgetFiltersLoading && <Loader />}
      <div>{renderWidgetFilters()}</div>
      <div className={styles.bottomContainer}>
        <div>
          <div className={styles.currentFilterTitle}>
            <TranslatedMessage {...messages.currentFiltersDefaultTitle} />
          </div>
          <div className={styles.filterPillsContainer}>
            {renderCurrentSelectedFilterValues()}
          </div>
        </div>
        {/* <div className={styles.checkboxContainer}>
          <div className={styles.labelContainer}>
            <Checkbox
              checked={applyAll}
              onChange={() => setApplyAll(value => !value)}
            />
            <span className={styles.checkboxLabel}>
              <TranslatedMessage {...messages.applyToAllDefaultLabel} />
            </span>
          </div>
          <div>
            <span className={styles.checkboxCaption}>
              <TranslatedMessage {...messages.applyToAllDefaultCaption} />
            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default WidgetFiltersTab;
